import { render } from "./ListPagination.vue?vue&type=template&id=65b7f8a1&bindings={\"listData\":\"props\",\"itemByPage\":\"props\",\"pageNumber\":\"props\",\"nextPage\":\"options\",\"prevPage\":\"options\",\"pageCount\":\"options\"}"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script